module.exports = __webpack_public_path__ + "static/assets/33b2c770e12dd94797701e92ae37a820.svg";